module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/brand/apple-392a7bc8b65810880bc2d63bbc197056.svg";